import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/**
 * Root shell. Every route renders inside OrderingLayoutComponent (its own red/black header +
 * footer), so this is a bare outlet — the marketing header/footer and the `isStorefront` toggle
 * that wrapped this portal in the product website have no counterpart here.
 */
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrls: ['./app.css'],
})
export class App {}
